export default {
  defaultButtonColor: '#f15628',
  defaultMainBackgroundColor: '#f5f5f5',
  loggedUser: {},
  mainBackgroundColor: '#f5f5f5',
};
